import React from 'react'

import {combine} from '../styles/classname-utils'
import styles from './pricing-faq-question.module.scss'

interface IPricingFaqQuestion {
  qid: string
  title: string
  html: string
}

const PricingFaqQuestion: React.FC<IPricingFaqQuestion> = ({qid, title, html}) => (
  <div className={styles.main}>
    <div className={styles.content}>
      <div className={combine('row', 'justify-content-center', styles.faqOpener)}>
        <div className={styles.header}>
          <button
            className={combine(styles.faqButton, 'btn', 'font8-bold', 'btn-block', 'text-left')}
            data-toggle='collapse'
            data-target={`#${qid}`}
            aria-expanded='false'
            aria-controls={qid}
            type='button'
          >
            <h4 className={combine(styles.faqButtonContent, 'mb-0', 'purple')}>
              {title}
            </h4>
          </button>
        </div>
      </div>
      <div
        id={qid}
        aria-labelledby={qid}
        data-parent={`#${qid}`}
        className='row collapse w-100 m-0'
      >
        <div>
          {/* eslint-disable-next-line react/no-danger */}
          <div dangerouslySetInnerHTML={{__html: html}} />
        </div>
      </div>
    </div>
  </div>
)

export default PricingFaqQuestion
